export default {
  router: null,
  route: null,
  to(...args) {
    this.router.push(...args)
  }
}
